import axios from "axios";
import { host } from "./utilities";

axios.defaults.withCredentials = true;
export const assetServiceUserPrincipleAxios = () => (config) => axios.get(`${host()}/user`, config);
export const assetServiceUserRolesAxios = () => (config) => axios.get(`${host()}/user/roles`, config);
